// Website section — storefront control panel.
// Phase 1: placeholder. The website session will build this out with
// product merchandising, featured items, banners, and SEO controls.
import { Globe, ExternalLink } from "lucide-react";
import { SectionHeader } from "@/pages/WorkflowPage";

export function WebsitePage() {
  return (
    <div className="mx-auto max-w-5xl">
      <SectionHeader
        icon={Globe}
        title="Website"
        description="Storefront, product merchandising, and content."
      />

      <div className="mt-10 rounded-lg border border-brown-100 bg-white p-10 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-cream-200">
          <Globe className="h-5 w-5 text-brown-400" />
        </div>
        <h2 className="font-display text-xl font-bold text-brown-500">
          Website controls coming next.
        </h2>
        <p className="mx-auto mt-2 max-w-md text-sm text-brown-400">
          Featured products, promotional banners, category merchandising, and
          SEO fields will be managed from here — no code required.
        </p>
        <a
          href="https://getmerchd.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-brown-500 underline-offset-2 hover:underline"
        >
          View storefront
          <ExternalLink className="h-3.5 w-3.5" />
        </a>
      </div>
    </div>
  );
}
